<div class="td-wb-help-mobile-article"
     [tdWbFocus]="hasFocus()"
     [attr.tabindex]="hasFocus()? 0 : -1"
     [innerHTML]="articleContent()">
</div>
@if (hasFocus()) {
  <a class="td-wb-vh"
     role="button"
     href=""
     (click)="backToIndex()">
    <span translate="tdWb.help.BACK_INDEX"></span>
  </a>
}
